import { AdvanceFilter } from '@/types/types';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface FilterStore {
  serviceFilters: AdvanceFilter[];
  setServiceFilters: (filters: AdvanceFilter[]) => void;
  deliveryFilters: AdvanceFilter[];
  setDeliveryFilters: (filters: AdvanceFilter[]) => void;
  hiFilters: AdvanceFilter[];
  setHIFilters: (filters: AdvanceFilter[]) => void;
  ddiFilters: AdvanceFilter[];
  setDDIFilters: (filters: AdvanceFilter[]) => void;
  reset: () => void;
}

export const useFilterStore = create<FilterStore>()(
  persist(
    (set) => ({
      serviceFilters: [],
      setServiceFilters: (serviceFilters) => set({ serviceFilters }),
      deliveryFilters: [],
      setDeliveryFilters: (deliveryFilters) => set({ deliveryFilters }),
      hiFilters: [],
      setHIFilters: (hiFilters) => set({ hiFilters }),
      ddiFilters: [],
      setDDIFilters: (ddiFilters) => set({ ddiFilters }),
      reset: () => set({ serviceFilters: [], deliveryFilters: [], hiFilters: [], ddiFilters: [] }),
    }),
    {
      name: 'filter-store',
      partialize: (state) => ({
        serviceFilters: state.serviceFilters,
        deliveryFilters: state.deliveryFilters,
        hiFilters: state.hiFilters,
        ddiFilters: state.ddiFilters,
      }),
    }
  )
);
